<script setup lang="ts">
import '@vuepic/vue-datepicker/dist/main.css'
</script>


<template>
  <Html class="text-gray-900 bg-white">
    <NuxtLayout />
  </Html>
</template>
